// PopupPortal.jsx
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const PopupPortal = ({
  isOpen,
  onClose,
  position,
  children,
  loading = false,
  width = 280,
  className = '',
}) => {
  const popupRef = useRef(null);

  // Click outside
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  // Reposition on scroll/resize
  useEffect(() => {
    if (!isOpen) return;
    const handleUpdate = () => {
      // The parent component already recalculates position and passes it down.
      // If you need the popup to reposition dynamically, you can emit an event here.
    };
    window.addEventListener('scroll', handleUpdate, true);
    window.addEventListener('resize', handleUpdate);
    return () => {
      window.removeEventListener('scroll', handleUpdate, true);
      window.removeEventListener('resize', handleUpdate);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      ref={popupRef}
      className={`popup-portal ${className}`}
      style={{
        position: 'fixed',
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 999999,
        backgroundColor: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
        width: `${width}px`,
        pointerEvents: loading ? 'none' : 'auto',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            zIndex: 1,
          }}
        >
          <i className="fas fa-spinner fa-spin" style={{ color: '#1976d2', fontSize: '24px' }} />
        </div>
      )}
      {children}
    </div>,
    document.body
  );
};

export default PopupPortal;